export default {
  'helix-layout':  () => import('@onify/helix-pages').then(({ HHelixLayout }) => HHelixLayout),
  'basic-layout':  () => import('@onify/helix-pages').then(({ HBasicLayout }) => HBasicLayout),
  'blank-layout':  () => import('@onify/helix-pages').then(({ HBlankLayout }) => HBlankLayout),
  'legacy-layout':  () => import('@onify/helix-pages').then(({ HLegacyLayout }) => HLegacyLayout),
  'citizen-layout':  () => import('../src/custom/layouts/citizen.vue')
  }